export default {
  'region_selector_global_tips': 'Player login country and region',
  'region_selector_global_message': 'Display data results based on de-duplicated users in all markets.',
  'region_selector_global_no_data_text': 'Including deduplicated data for all countries where the game was released.',
}